import { secureRefSplitApi } from './ref-api';

const logoTypesApi = secureRefSplitApi.injectEndpoints({
  endpoints: (build) => ({
    fetchLogoTypes: build.query<{ label: string; value: string }[], void>({
      query: () => ({
        url: '/logo-types',
        method: 'GET'
      })
    })
  }),
  overrideExisting: false
});

export const { useFetchLogoTypesQuery } = logoTypesApi;
